import React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import { Form, Input, Row, Col, Button, Upload, Icon, message, Radio } from 'antd';
import CsHelpTip from '../public/cs-help-tip';
import CsSelectMul from '../public/cs-select-mul';
import util from '../../util';
import TopForm from './TopForm';
const { getRandom } = util;
const RadioGroup = Radio.Group;
@inject('ecodeStore')
@observer
class App extends React.Component {
  static defaultProps = {
    prefixCls: 'ecode',
  }
  componentDidMount() {
    const { ecodeStore: { getFieldList, setMobxState, getDemoInfo } } = this.props;
    const hash = window.location.hash.split('?')[1];
    const querys = hash ? hash.split('&') : [];
    const params = {};
    querys.forEach((query) => {
      const len = query.indexOf('=');
      let key = query.slice(0, len);
      params[key] = query.slice(len+1);
    })
    setMobxState({ access_token: params.cs_token, id: params.id, secondaryModule: params.demotype, success: false });
    getFieldList({
      secondaryModule: params.demotype,
    }).then((data) => {
      if (data.status) {
        const tempData = data.list;
        setMobxState({ disabledSubmit: tempData.find((da) => da.conditionType === 'upload') });
      } else {
        setMobxState({ disabledSubmit: true });
      }
      getDemoInfo({
        id: params.id,
      }).then(() => {
        // 初始化表单
        this.initForm();
      });
    });
  }
  filterEmptyParams = (params) => {
    const param = {};
    if (params) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          param[key] = params[key];
        }
      });
    }
    return param;
  }
  initForm = () => {
    let { form, ecodeStore: { demoInfo, setMobxState, fieldList } } = this.props;
    demoInfo = toJS(demoInfo);
    fieldList = toJS(fieldList);
    if (form) {
      let params = {};
      fieldList.forEach((v) => {
        params[v.domkey] = demoInfo[v.domkey];
        if (v.domkey === 'industry') params.industry = demoInfo.genreList && demoInfo.genreList.length > 0 ? demoInfo.genreList.map((v) => v.g_id).join() : '';
        if (v.domkey === 'functions') params.functions = demoInfo.functionList && demoInfo.functionList.length > 0 ? demoInfo.functionList.map((v) => v.g_id).join() : '';
        if (v.domkey === 'uploadimg') {
          params.uploadimg = demoInfo.imageList || [];
          const imgData = params.uploadimg[0] || {};
          setMobxState({
            fileList: Object.keys(imgData).length === 0 ? [] : [{
              ...imgData,
              uid: imgData.id || getRandom('ecode'),
              name: imgData.imgName || imgData.thumbnailName ||'',
              status: 'done',
              response: '',
              url: imgData.imageLink || imgData.thumbnailLink || '',
            }],
            disabledSubmit: false,
          });
          this.previewImg(imgData, v);
        }
      })
      params = this.filterEmptyParams(params);
      form.setFieldsValue(params);
      setMobxState({
        formParams: params,
      })
    }
  }
  getFunctionsList = (data) => {
    const { form } = this.props;
    const { getFieldValue } = form;
    const paramsIndus = getFieldValue('industry');
    const industry = paramsIndus ? paramsIndus.split(',') : [];
    let res = [];
    if (data) {
      if (industry.length > 0) {
        industry.forEach((index) => {
          const re = data.find((da) => da.key === index);
          if (re) res = res.concat(re.funcList.filter((v) => v.key !== '0')); // 过滤选项：'全部';
        })
      } else {
        data.forEach((da) => {
          if (da.funcList) {
            const re = da.funcList.filter((v) => v.key !== '0'); // 过滤选项：'全部'
            res = res.concat(re);
          }
        });
      }
    }
    return res;
  }
  filterPropertyList = (data) => {
    const { form, ecodeStore: { formParams } } = this.props;
    const { getFieldValue } = form;
    const paramsFuncs = toJS(formParams).functions || getFieldValue('functions');
    const paramsIndus = toJS(formParams).industry || getFieldValue('industry');
    if (paramsFuncs && !paramsIndus) { // 选中职能且行业为空时，需要过滤行业的选项
      const res = [], selectedIndustry = [];
      if (data) {
        const functions = paramsFuncs.split(',');
        functions.forEach((index) => {
          const re = data.find((da) => da.funcList.find((v) => v.key === index));
          if (re && !res.find((v) => v.key === re.key)) {
            res.push(re);
            selectedIndustry.push(re.key);
          }
        });
        form.setFieldsValue({ 'industry': selectedIndustry.join() });
      }
      return res;
    }
    return data;
  }
  fetchData = (params = {}, domkey) => {
    const { ecodeStore: { getPropertyList, getKb, propertyLoading } } = this.props;
    let { ecodeStore: { propertyList } } = this.props;
    propertyList = toJS(propertyList);
    return new Promise((resolve) => {
      if (domkey === 'functions' || domkey === 'industry') {
        if (propertyList && propertyList.length > 0) {
          const functionsList = this.getFunctionsList(propertyList);
          if (domkey === 'functions'){
            resolve(functionsList);
            return;
          }
          resolve(this.filterPropertyList(propertyList));
          return;
        } else if (!propertyLoading) {
          getPropertyList(params).then((data) => {
            const functionsList = this.getFunctionsList(data);
            if (domkey === 'functions'){
              resolve(functionsList);
              return;
            }
            resolve(this.filterPropertyList(data));
          });
          return;
        }
        resolve([]);
      } else if (domkey === 'kbVersion') {
        getKb().then((data) => {
          resolve(data);
        });
        return;
      }
      resolve([]);
    });
  }
  getRules = (field) => {
    if (field.viewAttr === 'required') {
      return [{ required: true, message: `${field.label}未填写` }];
    }
    return [];
  }
  handlePreview = (field) => {
    window.open(field.previewImage);
  }
  previewImg = (res, field) => {
    const { ecodeStore: { setMobxState } } = this.props;
    let { ecodeStore: { fieldList } } = this.props;
    fieldList = toJS(fieldList);
    fieldList.forEach((singleField) => {
      if (singleField.domkey === field.domkey) {
        singleField.previewImage = res.imgLink || res.imageLink || res.thumbnailLink || '';
      }
    });
    setMobxState({ fieldList });
  }
  renderFields = (field) => {
    const { conditionType } = field;
    const { prefixCls, form, ecodeStore: { formParams, setMobxState, id, access_token, demoInfo } } = this.props;
    let { ecodeStore: { fileList } } = this.props;
    const { getFieldDecorator } = form;
    if (conditionType === 'browser') {
      return getFieldDecorator(field.domkey, {
        rules: this.getRules(field),
      })(
        <CsSelectMul
          {...field}
          value={toJS(formParams)[field.domkey]}
          fetchData={(params) => this.fetchData(params, field.domkey)}
          onChange={(ids) => {
            setMobxState({
              ...toJS(formParams),
              [`${field.domkey}`]: ids,
            });
            setTimeout(() => {
              if (field.domkey === 'functions') this.fetchData({}, 'industry');
            }, 0);
          }}
        />
      );
    }
    if (conditionType === 'upload') {
      fileList = toJS(fileList);
      return (
        <div className={`${prefixCls}-form-help-con`}>
          <Upload
            listType='picture-card'
            accept=".jpg, .jpeg, .png"
            action={window.server + "/v5/ecode/upPreviewImage"}
            data={{ id, cs_token: access_token, type: "usefile", folderId: toJS(demoInfo).folderId }}
            method="post"
            fileList={fileList}
            onChange={(info) => {
              setMobxState({ fileList: info.fileList, disabledSubmit: info.fileList.length === 0 });
              if (info.file.status === 'done') {
                setMobxState({ disabledSubmit: false });
                this.previewImg(info.file.response, field);
              }
              if (info.file.status === 'error') {
                setMobxState({ fileList: [], disabledSubmit: true });
                message.config({
                  top: 60,
                })
                message.error('上传错误');
              }
            }}
            onPreview={() => this.handlePreview(field)}
            {...field}
          >
            {
              fileList.length === 0 && (
                <Icon type="plus" />
              )
            }
          </Upload>
          <CsHelpTip title="提交表单前请先上传案例缩略图" width={200} placement="topLeft" className={`${prefixCls}-form-help-tip`}>
            <Icon type="question-circle" />
          </CsHelpTip>
        </div>
      );
    }
    if (conditionType === 'radio') {
      const options = field.options || [
        {key: 'workflowChart', name: '流程表单'},
        {key: 'workflowStyle', name: '流程样式'},
      ];
      return (
          getFieldDecorator(field.domkey, {
            rules: this.getRules(field),
          })(
              <RadioGroup value={toJS(formParams)[field.domkey]}>
                {
                  options && options.map((op) => (
                      <Radio key={op.key} value={op.key}>{op.name}</Radio>
                  ))
                }
              </RadioGroup>
          )
      );
    }
    return getFieldDecorator(field.domkey, {
      rules: this.getRules(field),
    })(
      <Input placeholder={`请输入${field.label}`} disabled={field.viewAttr === 'readonly'} />
    );
  }
  renderFormItem = () => {
    const { prefixCls } = this.props;
    let { ecodeStore: { fieldList } } = this.props;
    fieldList = toJS(fieldList);
    return fieldList.map((field) => {
      return (
          <Row className={`${prefixCls}-form`} key={field.domkey}>
            <Col span={6} className={`${prefixCls}-form-label`}>{field.label}：</Col>
            <Col span={18} className={`${prefixCls}-form-wrapper`}>
              <Form.Item className={`${prefixCls}-form-${field.viewAttr}`}>
                { this.renderFields(field) }
              </Form.Item>
            </Col>
          </Row>
      )
    });
  }
  //判断md是否上传了图片
  checkMd = () => {
    const { ecodeStore: { readme = '' } } = this.props;
    const hasPicture = /\!\[.*?\]\(/.test(readme);
    hasPicture || message.error('请上传图片');
    return hasPicture;
  }
  onSubmit = (closeForm = true, checkForm = true) => {
    const { form, ecodeStore: { fullDemoDetail } } = this.props;
    const { validateFields } = form;
    if (checkForm) {
      validateFields((err, values) => {
        const params = this.filterEmptyParams(values);
        if (!err) {
          const pass = this.checkMd();
          if (pass) {
            fullDemoDetail(params, closeForm).then(() => {
              form.resetFields();
              this.initForm();
            });
          }
        }
      });
    } else {
      let params = form.getFieldsValue();
      params = this.filterEmptyParams(params);
      fullDemoDetail(params, closeForm).then(() => {
        form.resetFields();
        this.initForm();
      });
    }
  }
  renderSuccess = () => {
    const { prefixCls } = this.props;
    return (
      <div className={`${prefixCls}-success`}>
        <Icon type="check-circle" theme="filled" style={{ fontSize: 60, color: '#98cd74' }} />
        <div>提交成功!</div>
      </div>
    );
  }
  render() {
    const { prefixCls, ...restProps } = this.props;
    const {  ecodeStore: { disabledSubmit, success, demoLoading } } = restProps;
    const enableMd = window.location.hash.indexOf('enableMd') >= 0;
    if (enableMd) return (<div className={`${prefixCls} ${prefixCls}-enableMd`}>
        {
          success ? this.renderSuccess() : (
            <Form key="ecode-enableMd-form">
              <TopForm {...restProps} renderFields={this.renderFields} onSubmit={this.onSubmit} />
            </Form>
          )
        }
      </div>
    );
    return (
      <div className={`${prefixCls}`}>
        <Row>
          {
            success ? this.renderSuccess() : (
              <Col span={10} offset={7}>
                <Form>
                  {this.renderFormItem()}
                </Form>
                <Row>
                  <Col span={18} offset={6}>
                    <Button type="primary" disabled={disabledSubmit} onClick={this.onSubmit}>提交</Button>
                  </Col>
                </Row>
              </Col>
            )
          }
        </Row>
      </div>
    )
  }
}

App = Form.create()(App);
export default App;


// WEBPACK FOOTER //
// ./src/components/ecode/index.js